export enum ReservationFailureReason {
  'FullCapacity' = 'Full',
  'ReservationExceedsTime' = 'ExceedingTime',
  'AlreadyVisited' = 'Late',
  'Impossible' = 'Impossible',
  'MaxVariation' = 'MaxVariation',
}
